import { Component, OnInit } from '@angular/core';
import {CinchDataService} from "../../../common/service/cinch-data.service";

@Component({
  selector: 'app-nav-test',
  templateUrl: './nav-test.component.html',
  styleUrls: ['./nav-test.component.scss']
})
export class NavTestComponent implements OnInit {
  navSeleted = "";
  typeSelected = "navbar";
  styleSelected = "";
  eventComponent = "";

  navs = {};
  nav = {};
  navTypes = ["navbar", "sidebar"];
  navStyles = ["", "nav-00", "nav-01", "nav-02", "nav-03", "nav-test"];

  constructor( private cinchData: CinchDataService ) { }

  ngOnInit() {
    this.cinchData.fetchNavsData();
    this.cinchData.navs$.subscribe(navs => this.navs = navs , e => console.log());
    this.cinchData.nav$.subscribe(nav => this.nav = nav , e => console.log());
  }

  getNav(id) {
    if (id) {
        this.cinchData.fetchNavData(id);
    }
  }
  getNavStyle(type) {
  }

  componentAction(event) {
    this.eventComponent = event;
  }
}
